import * as classNames from 'classnames'
import * as React from 'react'
import SubscriptionPlansPane from '../../../../containers/subscriptions/SubscriptionPane'
import UIMessages from '../../../../utils/ui-messages'
import { IOrgObj } from '../../../../types'
import CreateOrganizationBottomBar from '../CreateOrganizationBottomBar'

interface IOrganizationSubscriptionPaneProps {
  currentStep: number
  isSaving: boolean
  organization: IOrgObj
  orgId: string
  isEdit?: boolean
  isCompleted: boolean
  onCompleteStep: (step: number) => void
  onPlanSelect: (planId: string, stripeSourceId: string) => void
}

class OrganizationSubscriptionPane extends React.Component<IOrganizationSubscriptionPaneProps> {
  public render() {
    const { currentStep, isSaving, isEdit, orgId, onCompleteStep, organization } = this.props

    const bodyStyle = classNames(
      'flex',
      { 'pointer-events-auto opacity1': !isSaving },
      { 'pointer-events-none opacity04': isSaving }
    )
    const currentPlanId = organization.subscription ? organization.subscription.subscriptionPlanId : null
    const nextStepPath = isEdit
      ? `/organizations/${orgId}/edit/organization-location`
      : '/organizations/create/organization-location'
    const previousStepPath = isEdit
      ? `/organizations/${orgId}/edit/organization-info`
      : '/organizations/create/organization-info'

    return (
      <section>
        <div className={bodyStyle}>
          <div className='flex2'>
            {organization.unlimited ? (
              <div className='ml3 pt3 pb3'>This organization is unlimited to use Goin!</div>
            ) : (
              <SubscriptionPlansPane
                orgId={orgId}
                organization={organization}
                currentPlanId={currentPlanId}
                stripeSourceId={organization.subscription && organization.subscription.stripeSourceId}
                onPlanSelect={this.props.onPlanSelect}
              />
            )}
          </div>
        </div>
        <CreateOrganizationBottomBar
          isEdit={isEdit}
          isSaved={true}
          isSaving={false}
          nextStepPath={nextStepPath}
          previousStepPath={previousStepPath}
        />
      </section>
    )
  }
}

export default OrganizationSubscriptionPane



// WEBPACK FOOTER //
// ./src/components/organizations/create/organizationSubscriptionPane/OrganizationSubscriptionPane.tsx